export type CommonI18n = {
  skipToContent: string;

  cookies: {
    message: string;
    accept: string;
    decline: string;
  };
};

export const COMMON = {
  skipToContent: 'Ir para o conteúdo',

  cookies: {
    message:
      'Utilizamos cookies analíticos para melhorar a sua experiência. Pode aceitar ou recusar o seu uso.',
    accept: 'Aceitar',
    decline: 'Recusar',
  },
};
